import React from 'react'
import useForm from 'react-hook-form'
import useFetch from 'hooks/useFetch'
import { RHFInput } from 'react-hook-form-input'
import useSnackbar from 'hooks/useSnackbar'

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  Button,
} from '@material-ui/core'

import schemas from '../../schemas'
import constants from './../../../../../../constants'

import * as service from 'service'

const DialogTax = ({
  open,
  handleClose = () => {},
  onAction = () => {},
  tax,
}) => {
  const {
    register,
    unregister,
    handleSubmit,
    watch,
    setValue,
    errors,
  } = useForm({
    validationSchema: schemas.tax,
    defaultValues: {
      taxTypeId: 1,
      ...tax,
    },
  })
  const snackbar = useSnackbar()
  const { response, isLoading } = useFetch(service.recurrence.taxTypes.get)

  const taxType = watch('taxTypeId')
  const handleChangeType = e => {
    if (e.target.value === constants.taxTypes.PIS_COFINS_CSLL_TYPE) {
      return setValue('name', constants.taxTypes.PIS_COFINS_CSLL_TYPE_PIS_NAME)
    }
    setValue('name', '')
  }

  const onSubmit = async data => {
    if (!tax) {
      try {
        await service.recurrence.taxes.create({ tax: data })

        snackbar.open({
          message: 'Imposto criado com sucesso!',
          variant: 'success',
        })
        onAction()
        handleClose()
      } catch {
        snackbar.open({
          message: 'Falha ao criar imposto!',
          variant: 'error',
        })
        handleClose()
      }
    } else {
      try {
        await service.recurrence.taxes.update({ taxId: tax.id, tax: data })

        snackbar.open({
          message: 'Imposto atualizado com sucesso!',
          variant: 'success',
        })
        onAction()
        handleClose()
      } catch {
        snackbar.open({
          message: 'Falha ao atualizar imposto!',
          variant: 'error',
        })
        handleClose()
      }
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="new-tax">
      <DialogTitle id="form-dialog-title">
        <div>
          {tax ? (
            <Typography variant="h3">Editar imposto</Typography>
          ) : (
            <Typography variant="h3">Novo imposto</Typography>
          )}
        </div>
      </DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit(onSubmit)} id="tax-form">
          {taxType === constants.taxTypes.PIS_COFINS_CSLL_TYPE ? (
            <RHFInput
              as={
                <TextField
                  label="Nome"
                  margin="dense"
                  error={errors.name !== undefined}
                  select
                  SelectProps={{ native: true }}
                  helperText={
                    errors.name
                      ? errors.name.message
                      : 'Escolha entre PIS ou COFINS ou CSLL'
                  }
                  fullWidth
                >
                  <option
                    value={constants.taxTypes.PIS_COFINS_CSLL_TYPE_PIS_NAME}
                  >
                    PIS
                  </option>
                  <option
                    value={constants.taxTypes.PIS_COFINS_CSLL_TYPE_COFINS_NAME}
                  >
                    COFINS
                  </option>
                  <option
                    value={constants.taxTypes.PIS_COFINS_CSLL_TYPE_CSLL_NAME}
                  >
                    CSLL
                  </option>
                </TextField>
              }
              name="name"
              register={register}
              unregister={unregister}
              setValue={setValue}
            />
          ) : (
            <RHFInput
              as={
                <TextField
                  label="Nome"
                  margin="dense"
                  error={errors.name !== undefined}
                  helperText={
                    errors.name
                      ? errors.name.message
                      : "Insira o nome do imposto, por exemplo: 'PIS, COFINS'."
                  }
                  fullWidth
                />
              }
              name="name"
              unregister={unregister}
              register={register}
              setValue={setValue}
            />
          )}
          <RHFInput
            as={
              <TextField
                label="Escopo"
                margin="dense"
                error={errors.scope !== undefined}
                helperText={
                  errors.scope
                    ? errors.scope.message
                    : 'O escopo refere-se ao motivo/critério para aplicação do imposto.'
                }
                fullWidth
              />
            }
            name="scope"
            register={register}
            setValue={setValue}
          />
          {!isLoading && (
            <RHFInput
              as={
                <TextField
                  margin="dense"
                  label="Tipo do imposto"
                  variant="outlined"
                  error={!!errors.taxTypeId}
                  helperText={errors.taxTypeId && errors.taxTypeId.message}
                  SelectProps={{ native: true }}
                  select
                  fullWidth
                >
                  {response &&
                    response.data.taxTypes.map(taxType => (
                      <option key={taxType.id} value={taxType.id}>
                        {taxType.tag}
                      </option>
                    ))}
                </TextField>
              }
              name="taxTypeId"
              onChange={handleChangeType}
              unregister={unregister}
              register={register}
              setValue={setValue}
            />
          )}
          <RHFInput
            as={
              <TextField
                label="Valor"
                margin="dense"
                type="number"
                error={errors.value !== undefined}
                helperText={
                  errors.value
                    ? errors.value.message
                    : 'Porcentagem a ser aplicada'
                }
                fullWidth
              />
            }
            name="value"
            register={register}
            setValue={setValue}
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          form="tax-form"
        >
          Salvar
        </Button>
        <Button onClick={handleClose} color="primary" variant="outlined">
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogTax
